import React from 'react';
import PropTypes from 'prop-types';
import LoadingOverlay from 'components/shared/loaders/loading-overlay';

const View = ({ children, theme, loading, customClass }) => {
  const className = `px-20 pr-4 py-5 min-h-screen ${customClass} ${theme ? `bg-${theme}` : ''}`;
  return (
    <LoadingOverlay loading={loading}>
      <div className={className}>
        { children }
      </div>
    </LoadingOverlay>
  );
};

View.defaultProps = {
  loading: false,
  customClass: '',
}

View.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.string,
  loading: PropTypes.bool,
  customClass: PropTypes.string,
}

export default View;
